import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import type { ReturnTypeFromUseStudentFees } from '../../../api/student-fees';
import { PayFeesStepOne } from './step-one';
import { PayFeesStepTwo } from './step-two';
import { PayFeesSettingsProvider } from './store';

interface PayFeesModalProps {
  open: boolean;
  onClose: () => void;
  feesToPay: NonNullable<ReturnTypeFromUseStudentFees>[];
}

export function PayFeesModal({ open, onClose, feesToPay }: PayFeesModalProps) {
  const { t } = useTranslation(['common', 'fees']);

  return (
    <PayFeesSettingsProvider open={open} onClose={onClose}>
      {({ step, nextAction, previousStep, disableConfirm, isSubmitting }) => (
        <Dialog
          open={open}
          onClose={onClose}
          scroll="paper"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle onClose={onClose}>
            {t('fees:makePayment', { count: feesToPay.length })}
          </DialogTitle>
          <DialogContent>
            {step === 0 && <PayFeesStepOne feesToPay={feesToPay} />}
            {step === 1 && <PayFeesStepTwo />}
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              color="inherit"
              onClick={step === 0 ? onClose : previousStep}
            >
              {step === 0
                ? t('common:actions.cancel')
                : t('common:actions.back')}
            </Button>

            <Button
              loading={isSubmitting}
              type="submit"
              variant="contained"
              onClick={nextAction}
              disabled={disableConfirm}
            >
              {step === 0
                ? t('common:actions.next')
                : t('fees:completePayment')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </PayFeesSettingsProvider>
  );
}
